module.exports = __webpack_public_path__ + "img/1-11.c4d5a592.svg";